const $AppModal = {
  link:document.querySelector('.js-Application__link'),
  modal:document.querySelector('.js-ApplicationModal'),
  close:document.querySelectorAll('.js-Modal__close'),
}

$AppModal.link.addEventListener('click', function(){
  $AppModal.modal.classList.add('is-show');
});


let len = $AppModal.close.length;

for(var i = 0; i < len; i++ ) {
  $AppModal.close[i].addEventListener('click', function(){
    $AppModal.modal.classList.remove('is-show');
  });

}
